import { GpuVector } from "./gpuVector";
//TODO: extend from GeometryVector -> make topology vector optional
export class ConstGpuVector extends GpuVector {
    _numGeometries;
    _geometryType;
    constructor(_numGeometries, _geometryType, triangleOffsets, indexBuffer, vertexBuffer, topologyVector) {
        super(triangleOffsets, indexBuffer, vertexBuffer, topologyVector);
        this._numGeometries = _numGeometries;
        this._geometryType = _geometryType;
    }
    static create(numGeometries, geometryType, triangleOffsets, indexBuffer, vertexBuffer, topologyVector) {
        return new ConstGpuVector(numGeometries, geometryType, triangleOffsets, indexBuffer, vertexBuffer, topologyVector);
    }
    /*static createMortonEncoded(
        numGeometries: number,
        geometryType: number,
        triangleOffsets: Int32Array,
        indexBuffer: Int32Array,
        vertexOffsets: Int32Array,
        vertexBuffer: Int32Array,
        mortonInfo: MortonSettings
    ): GpuVector {
        //TODO: refactor to use unsigned integers
        return new ConstGpuVector(
            numGeometries,
            geometryType,
            VertexBufferType.MORTON,
            triangleOffsets,
            indexBuffer,
            vertexOffsets,
            vertexBuffer,
            mortonInfo
       );
    }*/
    geometryType(index) {
        return this._geometryType;
    }
    get numGeometries() {
        return this._numGeometries;
    }
    containsSingleGeometryType() {
        return true;
    }
}
//# sourceMappingURL=constGpuVector.js.map